import { useState } from 'react';
import { useI18n, type Key } from '../i18n';
import { Icon } from './icons';

const KEY = 'ft.tour.done';
const STEPS: { title: Key; text: Key; icon: keyof typeof Icon }[] = [
  { title: 'tour.1.t', text: 'tour.1.d', icon: 'home' },
  { title: 'tour.2.t', text: 'tour.2.d', icon: 'orders' },
  { title: 'tour.3.t', text: 'tour.3.d', icon: 'invoicing' },
  { title: 'tour.4.t', text: 'tour.4.d', icon: 'forecast' },
  { title: 'tour.5.t', text: 'tour.5.d', icon: 'help' },
];

export const tourDone = () => { try { return localStorage.getItem(KEY) === '1'; } catch { return true; } };
export const resetTour = () => { try { localStorage.removeItem(KEY); } catch { /* egal */ } };

/** Kurze Einführung beim ersten Besuch (je Browser); später unter Hilfe erneut startbar. */
export function Tour({ onClose }: { onClose: () => void }) {
  const { t } = useI18n();
  const [i, setI] = useState(0);
  const done = () => { try { localStorage.setItem(KEY, '1'); } catch { /* egal */ } onClose(); };
  const s = STEPS[i]!;
  return (
    <>
      <div className="scrim" onClick={done} />
      <div className="tour" role="dialog" aria-modal="true" aria-label={t('tour.label')}>
        <div className="tour-icon" aria-hidden="true">{Icon[s.icon]}</div>
        <h3>{t(s.title)}</h3>
        <p>{t(s.text)}</p>
        <div className="tour-dots" aria-hidden="true">{STEPS.map((_, k) => <i key={k} className={k === i ? 'on' : undefined} />)}</div>
        <div className="tour-f">
          <button className="btn ghost" onClick={done}>{t('tour.skip')}</button>
          <span className="spacer" />
          {i > 0 && <button className="btn" onClick={() => setI(i - 1)}>{t('tour.back')}</button>}
          {i < STEPS.length - 1 ? <button className="btn primary" onClick={() => setI(i + 1)} autoFocus>{t('tour.next')}</button> : <button className="btn primary" onClick={done} autoFocus>{t('tour.finish')}</button>}
        </div>
      </div>
    </>
  );
}
